import { Button } from '@mantine/core';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { viewerModel } from 'entities/viewer';
import { useBreakpoint } from 'shared/lib';
import { shiftsPageModel } from '../../model';
import { ShiftsPageShift } from '../shifts-page-shift';
import cls from './shifts-page-current.module.scss';

export const ShiftsPageCurrent = () => {
	const { t } = useTranslation();

	const [shift, id, pending, stopButtonClicked] = useUnit([
		shiftsPageModel.$shift,
		viewerModel.$id,
		shiftsPageModel.stopShiftMutation.$pending,
		shiftsPageModel.stopButtonClicked,
	]);

	const sm = useBreakpoint('sm');

	return (
		<>
			<ShiftsPageShift shift={shift} />
			<div className={cls.shiftsPageCurrentWrapper}>
				<Button
					data-test-id='shifts-page-stop-shift'
					size={sm ? 'xl' : 'lg'}
					loading={pending}
					disabled={id !== shift?.owner.id}
					onClick={stopButtonClicked}
				>
					{t('shifts-page.end-shift')}
				</Button>
			</div>
		</>
	);
};
